import axios from 'axios';

const API_BASE_URL = '/api';

console.log('API Client: Базовый URL:', API_BASE_URL);
console.log('API Client: Все переменные окружения:', process.env);

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерцептор для добавления токена авторизации
apiClient.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    if (user) {
      const userData = JSON.parse(user);
      // Если в будущем понадобится токен авторизации
      // config.headers.Authorization = `Bearer ${userData.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ошибок
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API методы для работы с транскрипциями и протоколами
export const transcriptionAPI = {
  upload: async (file: File,
      chatId: string,
      messageText?: string,
      diarize: boolean = true,
      onProgress?: (percent: number) => void) => {
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('chat_id', chatId);
    if (messageText) {
      formData.append('message_text', messageText);
    }
    formData.append('diarize', diarize.toString());

    try {
      const response = await apiClient.post('/extract_transcription', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (event) => {
          if (event.total) {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress?.(percent); // обновляем прогресс на фронтенде
          }
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getStatus: async (jobId: string) => {
    console.log('API: Проверяем статус для job_id:', jobId);
    try {
      const response = await apiClient.get(`/job_status?job_id=${jobId}`);
      console.log('API: Статус задачи:', response.data);
      return response.data;
    } catch (error) {
      console.error('API: Ошибка при проверке статуса:', error);
      throw error;
    }
  },

  download: async (transcriptionId: string) => {
    const response = await apiClient.get(`/get_transcription?transcription_id=${transcriptionId}`, {
      responseType: 'blob',
    });
    return response.data;
  },
};

export const transcriptionsAPI = {
  getList: async (chatId: string, limit: number = 50, offset: number = 0) => {
    console.log('API: Получаем список транскрипций для chat_id:', chatId);
    try {
      const response = await apiClient.get(`/transcriptions?chat_id=${chatId}&limit=${limit}&offset=${offset}`);
      console.log('API: Список транскрипций:', response.data);
      return response.data;
    } catch (error) {
      console.error('API: Ошибка при получении списка транскрипций:', error);
      throw error;
    }
  },
};

export const protocolsAPI = {
  getList: async (chatId: string, limit: number = 50, offset: number = 0) => {
    console.log('API: Получаем список протоколов для chat_id:', chatId);
    try {
      const response = await apiClient.get(`/protocols?chat_id=${chatId}&limit=${limit}&offset=${offset}`);
      console.log('API: Список протоколов:', response.data);
      return response.data;
    } catch (error) {
      console.error('API: Ошибка при получении списка протоколов:', error);
      throw error;
    }
  },
};

export const protocolAPI = {
  create: async (transcriptionId: string, config?: any, schemeType: string = 'TSU') => {
  // дефолтный config, если не передан
  const defaultConfig = {
    language: 'ru',
    has_speaker_identification: true,
    detail_level: 'средний',
    blocks: ['Участники', 'Описание', 'Заключение', 'Ответственность']
  };

  const finalConfig = {
    ...defaultConfig,
    ...(config ?? {})
  };

  // transcription_json_s3_id и scheme_type — query параметры
  const params = {
    transcription_json_s3_id: transcriptionId,
    scheme_type: schemeType
  };

  const response = await apiClient.post(
    '/get_protocol',
    finalConfig,     // ← JSON body (ВАЖНО!)
    { params }       // ← Query-параметры
  );

  return response.data;
},

  export: async (protocol: string, schemeType: string = 'TSU', fileExt: string = 'docx') => {
    const formData = new FormData();
    formData.append('protocol', protocol);
    formData.append('scheme_type', schemeType);
    formData.append('file_ext', fileExt);

    const response = await apiClient.post('/export_protocol_file', formData, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
